/* RegExp to find localization messages in source files to generate the file: */
// \$t\('[\w\d.\]+', ?\{[\w :',]+\}? ?\) ?/\* ?[\w \{\}']+ ?\*/

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { I18n } from 'aws-amplify';
import { messages, getLang, dateTimeFormats } from '@/locale'
import amplifyDict from '@/locale/amplify'


I18n.putVocabularies(amplifyDict);

Vue.use(VueI18n)

export default new VueI18n({
    locale: getLang(), // set locale
    fallbackLocale: 'en',
    messages, // set locale messages
    dateTimeFormats,
    pluralizationRules: {
      'cs': function(choice /*, choicesLength */) {
       // produkt | produkty | produktů 
       if(choice == 1) {
          return 0;
        }
        if(choice > 1 && choice < 5) {
          return 1;
        } else {
          return 2;
        }
      }
    }
  })
